<template>
    <FormModal :model="model" :init="init" modal-id="user_order" :is-enabled-view-mode="false" :hide-footer="true" ref="modal">
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_new">
                <b-form-group
                    label-cols-sm="2"
                    label="eBay注文番号"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.store_order_id"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.store_order_id" />
                </b-form-group>
            </template>
            <template v-else>
                <table class="table table-bordered table-hover">
                    <thead class="thead-dark">
                        <tr>
                            <th class="sticky-header" style="width: 50%;">Store</th>
                            <th class="sticky-header" style="width: 50%;">Inventory</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ model.store_id }}@{{ model.store_provider }}
                                <br>
                                {{ model.store_order_id }}
                            </td>
                            <td>
                                {{ model.inventory_id }}@{{ model.inventory_provider }}
                                <br>
                                {{ model.inventory_order_id }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>状態</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.order_status }}
                                </template>
                                <br>
                                <strong>タイトル</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.title }}
                                </template>
                                <br>
                                <strong>注文日時</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.ordered_at }}
                                </template>
                                <br>
                                <strong>SKU</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.sku }}
                                </template>
                                <br>
                                <strong>商品ID</strong><br>
                                <template v-if="model.store_order_detail">
                                    <a :href="model.store_order_detail.item_url" target="_blank">{{ model.store_order_detail.item_id }}</a>
                                </template>
                                <br>
                                <strong>購入者</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.address.Name }}<br>
                                    {{ [
                                        model.store_order_detail.address.Street1,
                                        model.store_order_detail.address.Street2,
                                        model.store_order_detail.address.CityName,
                                        model.store_order_detail.address.StateOrProvince,
                                        model.store_order_detail.address.PostalCode,
                                        model.store_order_detail.address.Country
                                    ].filter(Boolean).join(', ') }}
                                </template>
                                <br>
                                <strong>購入者TEL</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.address.Phone }}
                                </template>
                                <br>
                                <strong>金額</strong><br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.cost_total.currencyID }}
                                    {{ model.store_order_detail.cost_total.value }}
                                </template>
                                (合計代金)<br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.cost_price.currencyID }}
                                    {{ model.store_order_detail.cost_price.value }}
                                </template>
                                (商品代金)<br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.cost_shipping.currencyID }}
                                    {{ model.store_order_detail.cost_shipping.value }}
                                </template>
                                (配送代金)<br>
                                <template v-if="model.store_order_detail">
                                    {{ model.store_order_detail.cost_handling.currencyID }}
                                    {{ model.store_order_detail.cost_handling.value }}
                                </template>
                                (ハンドリング代金)<br>
                            </td>
                            <td>
                                <strong>状態</strong><br>
                                <template v-if="model.inventory_order_detail">
                                    {{ model.inventory_order_detail.fulfillmentOrder.fulfillmentOrderStatus }}
                                </template>
                                <br>
                                <strong>受取人向け記載テキスト</strong><br>
                                <template v-if="model.inventory_order_detail">
                                    {{ model.inventory_order_detail.fulfillmentOrder.displayableOrderComment }}
                                </template>
                                <br>
                                <strong>出荷指示受付日時</strong><br>
                                <template v-if="model.inventory_order_detail">
                                    {{ model.inventory_order_detail.fulfillmentOrder.displayableOrderDate }}
                                </template>
                                <br>
                                <strong>配送スピード</strong><br>
                                <template v-if="model.inventory_order_detail">
                                    {{ model.inventory_order_detail.fulfillmentOrder.shippingSpeedCategory }}
                                </template>
                                <br>
                                <strong>受取人</strong><br>
                                <template v-if="model.inventory_order_detail">
                                {{ model.inventory_order_detail.fulfillmentOrder.destinationAddress.name }}<br>
                                {{ [
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.addressLine1,
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.addressLine2,
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.city,
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.stateOrRegion,
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.postalCode,
                                    model.inventory_order_detail.fulfillmentOrder.destinationAddress.countryCode,
                                ].filter(Boolean).join(', ') }}
                                </template>
                                <br>
                                <strong>受取人TEL</strong><br>
                                <template v-if="model.inventory_order_detail">
                                    {{ model.inventory_order_detail.fulfillmentOrder.destinationAddress.phone }}
                                </template>
                                <br>
                                <template v-if="model.inventory_order_detail">
                                    <div v-for="(item, index1) in model.inventory_order_detail.fulfillmentOrderItems">
                                        <strong>内容物 #{{ index1 + 1 }}</strong><br>
                                        {{ item.sellerSku }}
                                        x{{ item.quantity }}
                                    </div>
                                </template>
                                <template v-if="model.inventory_order_detail">
                                    <div v-for="(shipment, index1) in model.inventory_order_detail.fulfillmentShipments">
                                        <strong>梱包 #{{ index1 + 1 }}</strong><br>
                                        {{ shipment.fulfillmentShipmentStatus }}(status)<br>
                                        {{ shipment.shippingDate }}(出荷日時)<br>
                                        {{ shipment.estimatedArrivalDate }}(到着予定日時)<br>
                                        <div v-for="(shipment_package, index2) in shipment.fulfillmentShipmentPackage">
                                            {{ shipment_package.trackingNumber }}@{{ shipment_package.carrierCode }}
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <strong>FBA出荷キャンセル日時</strong><br>
                <div v-if="model.inventory_order_detail">
                    <span v-if="model.canceled_at">{{ model.canceled_at }}</span>
                    <button v-else class="btn btn-danger" @click="cancel" :disabled="model.inventory_order_detail.fulfillmentOrder.fulfillmentOrderStatus !== 'Unshipped'">出荷キャンセルする</button>
                </div>
                <br>
                <strong>同期解除日時</strong><br>
                <div>
                    <span v-if="model.deleted_at">{{ model.deleted_at }}</span>
                    <button v-else class="btn btn-danger" @click="destroy">同期解除する</button>
                </div>
                <br>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import AddressContent from '@/components/AddressContent.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'

export default {
    components: {
        FormModal,
        AddressContent,
        SelectCountry,
        InputError,
        SelectCurrencyId,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
        async cancel(event) {
            console.log('cancel');
            if (event instanceof Event) {
                event.preventDefault()
            }
            if (!confirm('本当にFBA出荷キャンセルしますか？')) {
                return
            }
            this.error = {}
            return this.$store
                .dispatch('user_order/cancel', this.model)
                .then((response) => {
                    this.$bvModal.hide('user_order')
                    this.$bus.$emit('modal:saved', response.data.data)
                })
                ;
        },
        async destroy(event) {
            this.$refs.modal.destroy(event, false)
                .then((response) => {
                    this.$bus.$emit('modal:saved', response.data.data)
                })
                ;
        },
    },
}
</script>

<style lang="scss" scoped></style>


